export const removeScrollToQueryRegex = /&scrollTo=([^&#]+)/;
